import { setSpecificMessage, words } from "valibot";
setSpecificMessage(
  words,
  (issue) => `Mots invalide: reçu ${issue.received}`,
  "fr"
);